import $ from 'jquery';
import { publish } from "../01-helpers/event-manager";
import { COVEO_INITIALIZED } from "../02-const/event-names";

class CoveoSearch {

    constructor(el, options) {
        this.facets = [];
        this.lastFacet = '';
        this.el = el;
        this.options = options;

        this.init();
    }

    init() {
        $.ajax({ // no $.getScript as we want to cache the received script
            url: "/bundles/coveo",
            cache: true
        }).done(() => { this.setupCoveo(); this.bindEvents(); });

        if (this.options.editor) {
            $.ajax({ // no $.getScript as we want to cache the received script
                url: "/Coveo/js/PageEditorDeferRefresh.js",
                cache: true
            });
        }
    }

    setupCoveo() {
        if (typeof (Coveo) === 'undefined') {
            console.error('Coveo framework not loaded - cannot perform setup');
            return;
        }

        if (this.options.componentsOptions === 'undefined') {
            console.error('Coveo setup options not provided - cannot perform setup');
            return;
        }

        Coveo.$(() => {
            CoveoForSitecore.componentsOptions = this.options.componentsOptions;

            Coveo.$(this.el).coveoForSitecore('init', CoveoForSitecore.componentsOptions);
            let placeholder = "Waar bent u naar op zoek?";
            if (typeof (this.options.placeholder) === 'string') {
                placeholder = this.options.placeholder;
            }
            const input = document.querySelector('.CoveoQuerybox input');
            if (input !== null) {
                input.setAttribute("placeholder", placeholder);
            }
        });

        document.querySelectorAll('.CoveoFacet').forEach(this.setupFacets);

        this.initComplete();
    }

    setupFacets(element) {
        if (typeof (element.dataset.facetoptions) === "undefined") {
            return;
        }

        const facetOptions = element.dataset.facetoptions;
        CoveoForSitecore.componentsOptions = Coveo.$.extend({}, CoveoForSitecore.componentsOptions, facetOptions);
    }

    initComplete() {
        publish(COVEO_INITIALIZED);
    }

    bindEvents() {
        var self = this;

        // We use the Coveo framework/Coveo's version of jQuery as using the default jQuery doesn't handle the state:change event when fired (?!)
        if (typeof (Coveo) === 'undefined') {
            console.error('Coveo framework not loaded - cannot bind events');
            return;
        }
        Coveo.$(this.el).on('state:change:q', function (e, args) {
            Coveo.$('.CoveoFacet').coveo('reset'); // Reset facets on new query
            self.track(Coveo.$(self.el));
        });

        var firstFacetId = this.getFirstFacetId(Coveo.$(this.el));
        if (firstFacetId != null) {
            Coveo.$(this.el).on('state:change:f:' + firstFacetId, function (e, args) {
                self.facetClick(args.value);
            });
        }
    }

    facetClick(value) {
        var difference = [];
        var self = this;

        // Determine the last clicked facet by comparing the list of already active facets with the new selection
        jQuery.grep(value, function (el) {
            if (jQuery.inArray(el, self.facets) === -1) difference.push(el);
        });

        this.lastFacet = difference.join(',');
        this.facets = value;

        this.track(Coveo.$(self.el));
    }

    getFirstFacetId(el) {
        var facets = el.find('.CoveoFacet');
        if (facets.length === 0) {
            return null;
        }

        return facets.data('id');
    }

    getFacetValue(el) {
        return this.lastFacet;
    }

    getQueryValue(el) {
        return el.coveo('state', 'q');
    }

    // track using Google Analytics datalayer push
    track(el) {
        if (typeof (dataLayer) === "object") {
            var pushUri = document.location.pathname + '?search=' + encodeURIComponent(this.getQueryValue(el)) + '&searchcategory=' + encodeURIComponent(this.getFacetValue(el));
            dataLayer.push({ 'skipRegularPageTrack': 'true', 'event': 'virtualPageview', 'virtualDocumentPath': pushUri });
        }
    }
}

export { CoveoSearch as CoveoSearch };